import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Media } from 'reactstrap';
import ModalPreview from './ModalPreview';
import Forward from './New/Forward';
import { toLocalTime } from '../../../utils/helper';

const Body = ({ message, isRoot, all_in_one_tab }) => (
  <Media body>
    <Media
      heading
    >{`${message.user.salutation} ${message.user.first_name} ${message.user.last_name}`}</Media>
    <div className="chat_date">{toLocalTime(message.datetime)}</div>
    <div
      dangerouslySetInnerHTML={{
        __html: message.text
          ? message.text.replace(
              /(https?:\/\/[^\s]+)/g,
              all_in_one_tab ? '<a href="$1">$1</a>' : '<a href="$1" target="_blank">$1</a>',
            )
          : '',
      }}
    />
    <div>
      {message.file_link && (
        <Button onClick={() => ModalPreview(message)}>
          <img
            className='img-style'
            src={`${message.file_link}?h=128&w=128`}
            alt={message.original_name}
          />
        </Button>
      )}
      {message.note_text && (
        <Button onClick={() => ModalPreview(message)}>
          <i className="icon_c icon_c_bg icon_notes" />
        </Button>
      )}
    </div>
    {!message.shared && message.forwarded_message && (
      <Media className="forwarded_message_item">
        <Body message={message.forwarded_message} />
      </Media>
    )}
    {isRoot && (
      <div
        className="btn-secondary"
        style={{ float: 'right', backgroundColor: 'initial' }}
      >
        <i className="fa fa-check" />
        {message.status === 1 && (
          <i className="fa fa-check" style={{ marginLeft: -7 }} />
        )}
      </div>
    )}
  </Media>
);

Body.propTypes = {
  message: PropTypes.objectOf(PropTypes.any).isRequired,
  isRoot: PropTypes.bool,
};

const mapStateToProps = ({ user, i18n }) => ({
  userId: user.id,
  locale: i18n.locale,
});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

const MessageItem = ({ message, userId, locale, onAddComplete }) => (
  <Media
    className={`media_block float-${
      userId === message.user.id ? 'right' : 'left'
    }`}
  >
    <Media left>
      {userId !== message.user.id && (
        <img src={`${message.user.user_avatar}?h=64&w=64`} alt="" />
      )}
    </Media>
    <Body message={message} isRoot />
    <Media right>
      <Forward key={locale} message={message} onAddComplete={onAddComplete} />
    </Media>
    <div className="clear10" />
  </Media>
);

MessageItem.propTypes = {
  message: PropTypes.objectOf(PropTypes.any).isRequired,
  userId: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  onAddComplete: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageItem);



// WEBPACK FOOTER //
// ./src/views/_Chats/Messages/MessageItem.js